import { times } from "@aprao/common/src/util/times.js";
import type { ReadonlyTuple } from "type-fest";

export const completionLatch = <TCount extends number>(
  count: TCount,
  onAll: () => void,
) => {
  const promises: Array<Promise<void>> = [];
  const callbacks: Array<() => void> = [];

  times(count, () => {
    const promise = new Promise<void>((resolve) => {
      callbacks.push(resolve);
    });
    promises.push(promise);
  });

  // eslint-disable-next-line @typescript-eslint/no-floating-promises
  Promise.all(promises).then(onAll);

  return callbacks as ReadonlyTuple<() => void, TCount>;
};
